import icon from '@/components/Ui/SvgLoader.vue'
import HeaderTypo from '@/components/typography/h1.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Notifications from 'notiwind'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { register } from 'swiper/element/bundle'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light-border.css'
import 'tippy.js/themes/light.css'
import 'tippy.js/themes/material.css'
import 'tippy.js/themes/translucent.css'
import { Calendar, DatePicker, setupCalendar } from 'v-calendar'
import 'v-calendar/style.css'
import { createApp } from 'vue'
import VueTippy from 'vue-tippy'
import './assets/main.css'
import './assets/paginate.css'
import './assets/tippy.css'
import Loading from './components/Ui/Loading'
import i18n from './i18n/i18n'

import App from './App.vue'
import router from './router'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
pinia.use(({ store }) => (store.router = router))
pinia.use(piniaPluginPersistedstate)

app.use(VueTippy, {
  allowHTML: true
})

app.use(router)
app.use(i18n)
app.use(Notifications)
app.use(Loading)

// Use plugin defaults (optional)
app.use(setupCalendar, {})

// Use the components
app.component('VCalendar', Calendar)
app.component('VDatePicker', DatePicker)
app.component('FontAwesomeIcon', FontAwesomeIcon)
app.component('HeaderTypo', HeaderTypo)

app.mount('#app')

app.component('svg-icon', icon)

register()

window.$vue = app
window.$i18n = i18n
